jQuery(document).ready(function () {

    const container = jQuery('#typeahead');
    const input = jQuery('#search');

    jQuery(document).click(function() {
        if (!container.is(event.target) && !container.has(event.target).length) {
            container.hide();
        }
    });

    window.capture_photography_search = function(){
        jQuery.ajax({
            url: ajax_params.ajax_url,
            type: 'post',
            dataType: 'json',
            data: {
                action: 'capture_photography_ajax_search',
                nonce: ajax_params.nonce,
                keyword: input.val(),
            },
            success: function(data) {
                container.fadeIn(250, function () {
                    container.html(data.content);
                });
            },
            error: function (MLHttpRequest, textStatus, errorThrown) {
                console.log(errorThrown);
            },
        });
    }
});